import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-YOSPWY5K.mjs";

// src/form/error-message/error-message.tsx
import { clsx } from "@postenbring/hedwig-css/typed-classname";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var ErrorMessage = forwardRef(
  (_a, ref) => {
    var _b = _a, { children, id, className } = _b, rest = __objRest(_b, ["children", "id", "className"]);
    return /* @__PURE__ */ jsx(
      "div",
      __spreadProps(__spreadValues({
        "aria-live": "polite",
        className: clsx("hds-error-message", className),
        id,
        ref
      }, rest), {
        children
      })
    );
  }
);
ErrorMessage.displayName = "ErrorMessage";

export {
  ErrorMessage
};
//# sourceMappingURL=chunk-LHIG6RW7.mjs.map